import {
  PaymentTransactionTypeIds,
  defaultFilteredTransactionTypes,
} from "../types/PaymentTransactionTypes";
import { useBillingHistoryCtx } from "../context/BillingHistoryContext";
import { useTripsCtx } from "../context/TripDetailsContext";

export const useBillingHistoryFilterActions = (
  setIsOpenFilter: React.Dispatch<React.SetStateAction<boolean>>,
  onFilterCount: Function
) => {
  const { serviceDataCtx } = useTripsCtx();
  const [serviceData] = serviceDataCtx;

  const {
    filteredTransactionTypesCtx,
    checkedTransactionTypesCtx,
  } = useBillingHistoryCtx();
  const [, setFilteredTransactionTypes] = filteredTransactionTypesCtx;
  const [
    checkedTransactionTypes,
    setCheckedTransactionTypes,
  ] = checkedTransactionTypesCtx;

  const transactionTypesOptions: string[] = [
    "All",
    "Service",
    "Subscription",
    "Refund",
    "Credit",
  ];

  const serviceUsersOptions: string[] = [
    "All",
    ...serviceData.map(
      (user: { firstName: string; lastName: string }) =>
        `${user.firstName} ${user.lastName}`
    ),
  ];

  const totalCheckedFilterCount: number = checkedTransactionTypes.has("All")
    ? checkedTransactionTypes.size - 1
    : checkedTransactionTypes.size;

  const paymentTransactionTypeIds: Record<string, number> = {
    Service: PaymentTransactionTypeIds.Service,
    Refund: PaymentTransactionTypeIds.Refund,
    Credit: PaymentTransactionTypeIds.Credit,
    Subscription: PaymentTransactionTypeIds.Subscription,
    Other: PaymentTransactionTypeIds.Other,
  };

  const handleTransactionTypesClick = (option: string): void => {
    const newCheckedOptions = new Set(checkedTransactionTypes);

    if (option === "All") {
      newCheckedOptions.clear();
      newCheckedOptions.add("All");
    } else {
      if (checkedTransactionTypes.has(option)) {
        newCheckedOptions.delete(option);
        newCheckedOptions.delete("All");
      } else {
        newCheckedOptions.add(option);
        newCheckedOptions.delete("All");
        if (
          transactionTypesOptions
            .slice(1)
            .every((opt) => newCheckedOptions.has(opt))
        ) {
          newCheckedOptions.clear();
          newCheckedOptions.add("All");
        }
      }
    }
    setCheckedTransactionTypes(newCheckedOptions);
  };

  const handleReset = () => {
    setFilteredTransactionTypes(defaultFilteredTransactionTypes);
    setCheckedTransactionTypes(new Set(["All"]));
    onFilterCount(0);
    setIsOpenFilter(false);
  };

  const handleApplyFilters = () => {
    setFilteredTransactionTypes(
      checkedTransactionTypes.has("All")
        ? Object.values(paymentTransactionTypeIds)
        : [...checkedTransactionTypes].map(
            (transactionType: string) =>
              paymentTransactionTypeIds[transactionType]
          )
    );
    onFilterCount(totalCheckedFilterCount);
    setIsOpenFilter(false);
  };

  return {
    transactionTypesOptions,
    checkedTransactionTypes,
    handleApplyFilters,
    handleReset,
    handleTransactionTypesClick,
  };
};
